// src/components/AiDashboard/AiMyNutritionStatus/helpers/insufficientDataHelpers.js

import { MINIMUM_LOGGED_DAYS_FOR_TREND_ANALYSIS } from "../../../nutrition/nutritionConfig";

/**
 * Extracts the count of logged days from a nutritionTargetsCalculations snapshot.
 * 
 * Prefers intakeSummary.totalDaysLogged, falls back to counting keys in
 * rawDailyIntakeByDate if the preferred field is not available.
 * 
 * @param {Object} nutritionTargetsCalculationsSnapshot - The nutrition calculation snapshot
 * @returns {number} The number of logged days (0 if data is invalid/missing)
 */
export function getLoggedDayCount(nutritionTargetsCalculationsSnapshot) {
    if (!nutritionTargetsCalculationsSnapshot || typeof nutritionTargetsCalculationsSnapshot !== "object") {
        return 0;
    }

    const intakeSummary = nutritionTargetsCalculationsSnapshot.intakeSummary || {};

    // Prefer the explicit totalDaysLogged field
    if (typeof intakeSummary.totalDaysLogged === "number" && Number.isFinite(intakeSummary.totalDaysLogged)) {
        return intakeSummary.totalDaysLogged;
    }

    // Fallback: count dates in rawDailyIntakeByDate
    const rawDailyIntakeByDate = nutritionTargetsCalculationsSnapshot.rawDailyIntakeByDate || {};
    if (rawDailyIntakeByDate && typeof rawDailyIntakeByDate === "object") {
        return Object.keys(rawDailyIntakeByDate).length;
    }

    return 0;
}

/**
 * Checks whether a nutritionTargetsCalculations snapshot contains enough
 * logged days for meaningful trend analysis.
 * 
 * @param {Object} nutritionTargetsCalculationsSnapshot - The nutrition calculation snapshot
 * @param {number} [minimumLoggedDays=MINIMUM_LOGGED_DAYS_FOR_TREND_ANALYSIS] - The minimum threshold
 * @returns {boolean} True if logged days >= minimum threshold
 */
export function hasEnoughLoggedDaysForTrendAnalysis(
    nutritionTargetsCalculationsSnapshot,
    minimumLoggedDays = MINIMUM_LOGGED_DAYS_FOR_TREND_ANALYSIS
) {
    const loggedDayCount = getLoggedDayCount(nutritionTargetsCalculationsSnapshot);
    return loggedDayCount >= minimumLoggedDays;
}
